import React from 'react';
import { render } from 'react-dom';
import Router from './Router';

render(
    <Router />,
    document.querySelector('#main')
)




// WEBPACK FOOTER //
// ./src/index.js